import styled from 'styled-components'

export const VoidFlow = styled.div`
  display: flex;
  height: 682px;
  width: 100%;
`
